module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG798825e02bdc1279cd4a38c0903e639f.798825e0.png";